import React from 'react'
import { Card, CardBlock } from 'components/qstrap'

const CardContainer = props => (
  <Card className="bg-gray-lightest">
    <CardBlock className="p-y-md p-x-0">
      {props.children}
    </CardBlock>
  </Card>
)

export default CardContainer
